<template>
  <div class="form-floating mb-3">
    <select class="form-select" :id="property" @input="handleInput" :value="value"  :class="{'is-invalid': error }" :disabled="disabled">
      <option selected :value="null">Sélectionner</option>
      <option v-for="option in options" :key="option.value" :value="option.value">
        {{ option.text }}
      </option>
    </select>

    <label :for="property">{{ name }}<span class="text-danger" v-if="isRequired">*</span></label>
    <message-error :code="errorCode" :hasError="error"/>
  </div>
</template>

<script>
import MessageError from '@/core/components/MessageError.vue'

export default {
  name: 'SelectField',
  components: { MessageError },
  props: {
    value: { required: true },
    property: {},
    name: {},
    options: {},
    error: Boolean,
    disabled: Boolean,
    isRequired: {},
    errorCode: { type: String }
  },
  methods: {
    handleInput (e) {
      if(e.target.value === "") this.$emit('input', null)
      else this.$emit('input', e.target.value)
    }
  }
}
</script>

<style scoped>
select {
  border-radius: 0 !important;
}
</style>
